// extracted by mini-css-extract-plugin
export default {"empty_cart":"EmptyCart_empty_cart__37U2d","icon":"EmptyCart_icon__NoF7X","shop_button":"EmptyCart_shop_button__NHvAO"};